import React from "react";
import { TransportationForm } from "./Forms/TransportationForm";
import { useCreateTransportationMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateTransportation = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name: "",
      code: "",
    },
  });

  const { mutate: createTransportation, isPending } = useCreateTransportationMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createTransportation(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_TRANSPORTATION")} />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <TransportationForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_TRANSPORTATION")}
              </>
            ) : (
              t("CREATE_TRANSPORTATION")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};

